<div class="dash-shell">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <a class="page-head__crumb" routerLink="/dashboard">Home</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <a class="page-head__crumb" routerLink="/admin/dashboard">Admin</a>
      <span class="page-head__sep" aria-hidden="true">/</span>
      <span class="page-head__crumb page-head__crumb--current" aria-current="page"
        >Compliance &amp; security</span
      >
    </nav>
    <div class="page-head__bar">
      <div class="page-head__titles">
        <h1 class="page-head__title">Compliance &amp; security</h1>
        <p class="page-head__subtitle">
          Outstanding POPIA and security items from the latest security review. Engineering updates
          this register as work ships.
        </p>
      </div>
      <div class="page-head__actions">
        <button mat-stroked-button type="button" (click)="load()" [disabled]="loading()">
          Refresh
        </button>
      </div>
    </div>
  </header>

  @if (loading()) {
    <div class="comp-state">
      <mat-spinner diameter="28" />
      <span>Loading compliance status…</span>
    </div>
  } @else if (error()) {
    <div class="comp-state comp-state--error">
      <app-icon name="alert-triangle" [size]="20" />
      <span>Could not load the compliance status. Try refreshing.</span>
    </div>
  } @else if (report(); as r) {
    <!-- Summary -->
    <div class="comp-summary">
      <div class="comp-summary__count">
        <span class="comp-summary__num">{{ r.counts.outstanding }}</span>
        <span class="comp-summary__label">Outstanding</span>
      </div>
      <div class="comp-summary__badges">
        @if (r.counts.high > 0) {
          <span class="comp-badge comp-badge--high">{{ r.counts.high }} high</span>
        }
        @if (r.counts.medium > 0) {
          <span class="comp-badge comp-badge--medium">{{ r.counts.medium }} medium</span>
        }
        @if (r.counts.low > 0) {
          <span class="comp-badge comp-badge--low">{{ r.counts.low }} low</span>
        }
        @if (r.counts.needs_verification > 0) {
          <span class="comp-badge comp-badge--verify"
            >{{ r.counts.needs_verification }} to verify</span
          >
        }
        @if (r.counts.outstanding === 0) {
          <span class="comp-badge comp-badge--clear">All clear</span>
        }
      </div>
    </div>

    <!-- Items -->
    <ul class="comp-list">
      @for (item of r.items; track item.key) {
        <li
          class="comp-item"
          [class.comp-item--resolved]="item.status === 'resolved'"
          [attr.data-severity]="item.severity"
        >
          <div class="comp-item__head">
            <span class="comp-sev comp-sev--{{ item.severity }}">{{ item.severity }}</span>
            <h2 class="comp-item__title">{{ item.title }}</h2>
            <span class="comp-status comp-status--{{ item.status }}">
              {{ statusLabel(item.status) }}
            </span>
          </div>

          <p class="comp-item__detail">{{ item.detail }}</p>

          <div class="comp-item__remediation">
            <app-icon name="arrow-right" [size]="15" />
            <span>{{ item.remediation }}</span>
          </div>

          <div class="comp-item__meta">
            <span class="comp-tag">{{ item.area }}</span>
            <span class="comp-tag comp-tag--ref">{{ item.audit_ref }}</span>
          </div>
        </li>
      }
    </ul>
  }
</div>
